import call from "./call";
import {
  CreateKnowledgeBaseResponse,
  GetAllKnowledgeBasesResponse,
  GetSingleKnowledgeBaseResponse,
  Document as KnowledgeBaseDocument,
} from "../Models/knowledge";
import { Pipeline } from "../Enums/pipeline";

export const createKnowledgeBase = async (
  name: string,
  description: string,
  files: File[],
  pipeline: Pipeline = Pipeline.LEGACY
): Promise<CreateKnowledgeBaseResponse> => {
  const formData = new FormData();

  formData.append("name", name);
  formData.append("description", description);
  formData.append("pipeline", pipeline);
  files.forEach((file) => {
    formData.append("files", file);
  });

  const response = await call.post<CreateKnowledgeBaseResponse>(
    "/v1/knowledge_base/",
    formData,
    {
      snack: {
        success: "knowledge.createdSuccess",
        error: "knowledge.createError",
      },
    }
  );

  return response.data;
};

export const getKnowledgeBase = async () => {
  const response = await call.get<GetAllKnowledgeBasesResponse[]>(
    "/v1/knowledge_base/"
  );
  return response.data;
};

export const getSingleKnowledgeBase = async (
  id: number
): Promise<GetSingleKnowledgeBaseResponse> => {
  const { data } = await call.get<GetSingleKnowledgeBaseResponse>(
    `/v1/knowledge_base/${id}/`
  );
  return data;
};

export const updateSingleKnowledgeBase = async (
  id: number | null,
  name: string = "",
  description: string = ""
) => {
  const response = await call.put(
    `/v1/knowledge_base/${id}/`,
    {
      name: name,
      description: description,
    },
    {
      snack: {
        404: "knowledge.notFound",
        success: "knowledge.updatedSuccess",
        error: "knowledge.updateError",
      },
    }
  );
  return response;
};

export const deleteKnowledgeBase = async (id: number): Promise<void> => {
  await call.delete(`/v1/knowledge_base/${id}/`, {
    snack: {
      success: "knowledge.deletedSuccess",
      error: "knowledge.deleteError",
    },
  });
};

export const addKnowledgeBaseDocuments = async (
  knowledgeBaseId: number,
  files: File[],
  pipeline: Pipeline = Pipeline.LEGACY
) => {
  const formData = new FormData();
  formData.append("pipeline", pipeline);
  files.forEach((file) => {
    formData.append("files", file);
  });

  const response = await call.post(
    `/v1/knowledge_base/${knowledgeBaseId}/documents/`,
    formData,
    {
      snack: {
        success: "knowledge.documentsUploadedSuccess",
        error: "knowledge.documentsUploadError",
      },
    }
  );

  return response.data;
};

export const getKnowledgeBaseDocuments = async (
  knowledgeBaseId: number
): Promise<KnowledgeBaseDocument[]> => {
  const { data } = await call.get<{ documents: KnowledgeBaseDocument[] }>(
    `/v1/knowledge_base/${knowledgeBaseId}/documents/`
  );
  return data.documents;
};

export const deleteKnowledgeBaseDocument = async (
  documentId: number
): Promise<void> => {
  await call.delete(`/v1/knowledge_base/document/${documentId}/`, {
    snack: {
      423: "knowledge.documentLockedError",
      success: "knowledge.documentDeletedSuccess",
      error: "knowledge.documentDeleteError",
    },
  });
};

export const stopKnowledgeBase = async (id: number) => {
  const response = await call.post(`/v1/knowledge_base/stop/${id}/`, {
    snack: {
      error: "knowledge.stopError",
    },
  });
  return response;
};
